export const device = {
  phone: "only screen and (max-width: 575.98px)",
  tabPort: "only screen and (max-width: 767.98px)",
  tabLand: "only screen and (max-width: 991.98px)",
  desktop: "only screen and (max-width: 1199.98px)"
};
